/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Tool_Visit_AriaInputs */

const en_directory_tool_visit_aria = /** @type {(inputs: Directory_Tool_Visit_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visit ${i?.name}`)
};

const zh_directory_tool_visit_aria = /** @type {(inputs: Directory_Tool_Visit_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`访问 ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Visit {name}" |
*
* @param {Directory_Tool_Visit_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tool_visit_aria = /** @type {((inputs: Directory_Tool_Visit_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tool_Visit_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tool_visit_aria(inputs)
	return zh_directory_tool_visit_aria(inputs)
});
export { directory_tool_visit_aria as "directory.tool.visit_aria" }